import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'splitSpace',
    standalone: false
})
export class SplitBySpacePipe implements PipeTransform {

  transform(str: string): any {
    return str.split(' ');
  }

}
